<template>
    <section class="section-padding bg-light-gray px-2" id="faq">
        <h2 class="text-center mb-5">Često postavljena pitanja</h2>
        <div
            class="accordion accordion-flush max-w-lg mx-auto"
            id="faq-accordion"
        >
            <div
                v-for="(item, index) in faq"
                :key="index"
                class="accordion-item bg-transparent"
            >
                <h2 class="accordion-header" :id="`item-${index}`">
                    <button
                        class="accordion-button bg-transparent text-dark fw-medium"
                        :class="{ collapsed: index !== 0 }"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="`#question-${index}`"
                        :aria-expanded="index === 0 ? 'true' : 'false'"
                        :aria-controls="`question-${index}`"
                        v-html="item.question"
                    />
                </h2>
                <div
                    :id="`question-${index}`"
                    class="accordion-collapse collapse"
                    :class="{ show: index === 0 }"
                    :aria-labelledby="`item-${index}`"
                    data-bs-parent="#faq-accordion"
                >
                    <div class="accordion-body">
                        <p v-html="item.answer" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const faq = [
    {
        question: "Kako da instaliram i ažuriram aplikaciju?",
        answer: `
            Ako si postojeći korisnik Euro Petrol aplikacije, nakon izlaska nove verzije telefon će ti ponuditi opciju ažuriranja aplikacije. Potrebno je samo da izabereš Update/Ažuriraj. Nakon ažuriranja, potrebno je da se ponovo registruješ koristeći svoju email adresu i broj telefona. Na email i mobilni telefon dobićeš kodove koje unosiš u označena polja u aplikaciji. Proces traje kratko, a nakon uspešne registracije automatski ćeš biti uključen u Program lojalnosti sa poenima.
            <br /><br />
            Ako si novi korisnik, Euro Petrol aplikaciju možeš preuzeti iz Google Play, Huawei AppGallery ili Apple App Store prodavnice. Nakon instalacije, potrebno je da prođeš proces registracije unosom email adrese i broja telefona.
            Na email i mobilni telefon dobićeš kodove za potvrdu. Kada ih uneseš u aplikaciju, registracija je završena i automatski postaješ deo Programa lojalnosti sa poenima.
        `,
    },
    {
        question:
            "Koja je razlika između programa sa poenima i programa sa dinarskim popustom? Koji program donosi više benefita?",
        answer: `
            U programu sa poenima skupljaš poene pri kupovini i koristiš ih za umanjenje računa. Jedan poen vredi jedan dinar. Kroz ovaj program napreduješ kroz nivoe, a što je tvoj nivo viši, ostvaruješ veće pogodnosti. 
            <br /><br />
            U programu sa dinarskim popustom ostvaruješ automatski popust pri svakoj kupovini, prema važećoj skali popusta. Popust je fiksan i ne menja se u zavisnosti od tvoje potrošnje.
            <br /><br />
            Program lojalnosti sa poenima donosi svakako veće benefite jer što je korisnik na većem nivou, ostvaruje bolje pogodnosti. Žuti nivo jednak je dinarskom popustu. Zeleni i Expert nivo donosi mnogo značajnije uštede. Na kraju, u zavisnosti od tvojih ličnih navika i preferencija ostavili smo ti na izbor da koristiš program koji ti više odgovara.
        `,
    },
    {
        question: "Kako skupljam i koristim poene? ",
        answer: `
            Poene skupljaš kupovinom naftnih derivata, Lion Expert proizvoda i usluga na Euro Petrol benzinskim stanicama. Poeni se automatski evidentiraju na tvom nalogu u aplikaciji, a stanje poena možeš da pratiš u svakom trenutku.
            Kada želiš da iskoristiš poene, prilikom plaćanja pokaži svoj personalizovani QR kod iz aplikacije i obavesti kasira da želiš da ih iskoristiš za umanjenje računa.
            <br /><br />
            Jedan poen vredi jedan dinar, pa se iznos računa umanjuje za vrednost poena koje imaš na raspolaganju.
            Važno je da znaš da se poeni koriste u celosti. To znači da nije moguće iskoristiti samo deo poena — prilikom korišćenja, svi dostupni poeni biće iskorišćeni za umanjenje računa.
        `,
    },
    {
        question:
            "Da li mogu da promenim Program lojalnosti sa dinarskim popustom u Program lojalnosti sa poenima i obrnuto? Kako da promenim? ",
        answer: `
            Da, možeš promeniti program lojalnosti iz Programa sa dinarskim popustom u Program sa poenima, kao i obrnuto.
            <br /><br />
            Pre promene programa važno je da znaš da svaki program funkcioniše drugačije. U Programu sa dinarskim popustom ostvaruješ automatski popust pri kupovini, prema važećoj skali popusta. U Programu sa poenima skupljaš poene, napreduješ kroz nivoe i koristiš poene za umanjenje računa.
            <br /><br />
            Ukoliko pređeš sa Programa sa dinarskim popustom na Program sa poenima, gubiš mogućnost za instant popuste ali prikupljanje poena započinješ ispočetka, od početnog Žutog nivoa. Ukoliko pređeš sa Programa sa poenima na Program sa dinarskim popustom, gubiš ostvareni nivo i sve prikupljene poene. Ako se kasnije ponovo vratiš na Program sa poenima, prikupljanje poena započinješ ispočetka, od početnog nivoa. Zato je preporuka da izabereš program koji najviše odgovara tvojim navikama kupovine.
            <br /><br />
            Da pređeš sa Programa lojalnosti sa poenima na dinarski popust prati sledeće korake: Početna stranica, Više, Moj profil, Lojalnost, na dnu stranice nalazi se dugme deaktiviraj program lojalnosti.   Da pređeš sa Programa lojalnosti sa dinarskim popustom, prati sledeće korake: Početna stranica, Lojalnost, pritisni dugme AKTIVIRAJ PROGRAM SA POENIMA.
        `,
    },
    {
        question:
            "Da li mogu koristiti Euro Petrol klub Karticu za fizička lica i aplikaciju u isto vreme ili biram samo jedno?",
        answer: `
            Godinama unazad kupci Euro Petrola - fizička lica, koriste Euro Petrol klub Karticu za fizička lica ili aplikaciju za fizička lica. Euro Petrol klub kartica za fizička lica i aplikacija omogućavaju ostvarivanje istih pogodnosti pri kupovini, ali se ne mogu koristiti istovremeno u istoj transakciji. To znači da pri jednoj kupovini možeš koristiti samo jednu opciju: Euro Petrol klub karticu, verziju aplikacije sa dinarskim popustom ili novu verziju aplikacije sa prikupljanjem i trošenjem poena.
            <br /><br />
            Možeš imati i karticu i aplikaciju, ali prilikom svake kupovine biraš šta želiš da koristiš. Na primer, pri jednoj kupovini možeš koristiti karticu, a pri sledećoj aplikaciju. U novoj aplikaciji možeš izabrati Program lojalnosti sa dinarskim popustom ili Program lojalnosti sa poenima. Bez obzira na izabrani program, pogodnosti iz kartice i aplikacije ne mogu se sabirati niti koristiti paralelno u okviru iste transakcije.
        `,
    },
    {
        question:
            "Da li je moja platna kartica koju unesem u aplikaciju bezbedna?",
        answer: `
            Da, podaci tvoje platne kartice su bezbedni. Euro Petrol sarađuje sa kompanijom WS Pay, koja je zadužena za obradu i čuvanje podataka o platnim karticama. Podaci o kartici su zaštićeni i ne čuvaju se direktno u Euro Petrol aplikaciji.
            <br />
            Ukoliko promeniš program lojalnosti, tvoje sačuvane platne kartice neće biti obrisane. Takođe, podaci o kompaniji koje si uneo u delu „Moja kompanija” ostaju sačuvani. Međutim, ako deaktiviraš profil i zatim se ponovo registruješ ili prijaviš, potrebno je da ponovo uneseš podatke o kompaniji, uključujući PIB.
        `,
    },
];
</script>

<style scoped>
.accordion-button::after {
    background-image: none !important;
    font-size: 24px;
    line-height: 20px;
}

.accordion-button.collapsed::after {
    content: "+";
    transform: none;
}

.accordion-button:not(.collapsed)::after {
    content: "–";
    margin-right: -0.125rem;
    transform: none;
    color: var(--color-main);
}

.accordion-button {
    border: none !important;
    box-shadow: none !important;
}

.accordion-item:has(.accordion-button:not(.collapsed)) {
    border-bottom: 1px solid var(--color-main) !important;
}

.accordion-body {
    font-weight: 300;
}
</style>
